import {Modal, Button} from 'react-bootstrap'

interface Props {
  show: boolean
  workflowName?: string
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const ModalDeleteWorkflow: React.FC<Props> = ({
  show,
  workflowName,
  onClose,
  onConfirm,
  loading,
}) => {
  const handleConfirm = () => {
    if (
      window.confirm(
        'Deleting this board will permanently remove all its columns and tasks. Are you sure you want to proceed?'
      )
    ) {
      onConfirm()
    }
  }

  return (
    <Modal show={show} onHide={onClose} centered className='kanban-delete-workflow-modal'>
      <Modal.Header closeButton className='kanban-delete-workflow-modal__header'>
        <Modal.Title>Delete Board</Modal.Title>
      </Modal.Header>
      <Modal.Body className='kanban-delete-workflow-modal__body'>
        <p>
          Are you sure you want to delete the board <strong>{workflowName ?? ''}</strong>? This
          action cannot be undone and all associated columns and tasks will be permanently deleted.
        </p>
      </Modal.Body>
      <Modal.Footer className='kanban-delete-workflow-modal__footer'>
        <Button variant='light' onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant='danger' onClick={handleConfirm} disabled={loading}>
          {loading ? 'Deleting...' : 'Delete Board'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
